import React from 'react';

/**
 * 💳 Componente de Botón de PayPal
 * 
 * Formulario de pago directo a PayPal
 */
const PayPalButton = ({ userId }) => {
  const paypalEmail = 'ceed.educacion@gmail.com';

  return (
    <div style={{ textAlign: 'center' }}>
      {/* Formulario de PayPal */}
      <form 
        action="https://www.paypal.com/cgi-bin/webscr" 
        method="post" 
        target="_blank"
        style={{ marginBottom: '1.5rem' }}
      >
        <input type="hidden" name="cmd" value="_xclick" />
        <input type="hidden" name="business" value={paypalEmail} />
        <input type="hidden" name="item_name" value="Suscripción Premium GeopoliticaIA - 30 días" />
        <input type="hidden" name="amount" value="2.00" />
        <input type="hidden" name="currency_code" value="USD" />
        <input type="hidden" name="return" value={`${window.location.origin}/subscribe?success=true`} />
        <input type="hidden" name="cancel_return" value={`${window.location.origin}/subscribe?cancelled=true`} />
        <input type="hidden" name="custom" value={userId} />
        
        <button
          type="submit"
          style={{
            width: '100%',
            padding: '1rem 2rem',
            background: '#0070ba',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '1.2rem',
            fontWeight: 'bold',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.75rem',
            boxShadow: '0 4px 12px rgba(0, 112, 186, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#005ea6';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 112, 186, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#0070ba';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 112, 186, 0.3)';
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.067 8.478c.492.88.556 2.014.3 3.327-.74 3.806-3.276 5.12-6.514 5.12h-.5a.805.805 0 00-.794.68l-.04.22-.63 3.993-.028.15a.805.805 0 01-.794.68H7.72a.483.483 0 01-.477-.558L8.926 13.7a.805.805 0 01.794-.68h2.344c4.323 0 7.255-2.203 8.003-6.542z"/>
            <path d="M8.926 13.7a.805.805 0 00-.794.68l-1.682 10.69a.483.483 0 00.477.558h3.347c.346 0 .64-.25.694-.593l.028-.15.63-3.993.04-.22a.805.805 0 01.794-.68h.5c3.238 0 5.774-1.314 6.514-5.12.256-1.313.192-2.446-.3-3.327-.543-.974-1.632-1.646-3.057-2.027z"/>
          </svg>
          Pagar $2 USD con PayPal
        </button>
      </form>
      
      <div style={{
        padding: '1rem',
        background: 'rgba(59, 130, 246, 0.1)',
        borderRadius: '0.5rem',
        border: '1px solid rgba(59, 130, 246, 0.3)',
        marginBottom: '1rem'
      }}>
        <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
          📧 Después de pagar, envía el comprobante a:
        </p>
        <p style={{ color: '#3b82f6', fontWeight: 'bold', fontSize: '1rem', marginBottom: '0.5rem' }}>
          {paypalEmail}
        </p>
        <p style={{ color: '#64748b', fontSize: '0.85rem' }}>
          Incluye tu ID de usuario: <code style={{ background: 'rgba(0,0,0,0.3)', padding: '0.25rem 0.5rem', borderRadius: '0.25rem' }}>{userId?.substring(0, 8)}...</code>
        </p>
      </div>

      <div style={{
        padding: '1rem',
        background: 'rgba(245, 158, 11, 0.1)',
        borderRadius: '0.5rem',
        border: '1px solid rgba(245, 158, 11, 0.3)'
      }}>
        <p style={{ color: '#f59e0b', fontSize: '0.9rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
          ⚡ Proceso de Activación
        </p>
        <ol style={{ 
          color: '#94a3b8', 
          fontSize: '0.85rem',
          textAlign: 'left',
          paddingLeft: '1.5rem',
          margin: 0
        }}>
          <li>Haz clic en "Pagar con PayPal"</li>
          <li>Completa el pago de $2 USD</li>
          <li>Envía el comprobante + tu ID al correo</li>
          <li>Tu suscripción será activada en 24 horas</li>
        </ol>
      </div>
    </div>
  );
};

export default PayPalButton;
